import { TestIdDomain } from 'constants/testIds';

const ActivitiesTestIdsScope = {
  ACTIVITIES_FILTER: 'activities-filter',
  CALL_ACTIVITY_ITEM: 'call-activity-item',
  CALL_NOTES: 'call-notes',
  EMAIL_ACTIVITY_ITEM: 'email-activity-item',
  EMAIL_STATUS_POPUP: 'email-status-popup',
  CONTACTS_COLUMN: 'contacts-column',
  EMAIL_QUOTED_CONTENT: 'email-quoted-content',
  EMAIL_ATTACHMENTS: 'email-attachments',
  NEW_EMAIL_BODY: 'new-email-body',
  SNIPPETS_POPOVER: 'snippets-popover',
  NEW_EMAIL_FIELDS: 'new-email-fields',
  RECIPIENTS_FIELDS: 'recipients-fields',
  NEW_EMAIL_FOOTER: 'new-email-footer',
};

export const ActivitiesTestIds = {
  EMAIL_ACTIVITY_ITEM_UNFOLD_ICON_BUTTON: `${ActivitiesTestIdsScope.EMAIL_ACTIVITY_ITEM}.unfold-icon-button`,

  // ActivitiesList.js
  CREATE_EMAIL_BUTTON: `${TestIdDomain.ACTIVITIES}.create-email-button`,
  SHOW_ALL_CONTACTS_BUTTON: `${TestIdDomain.ACTIVITIES}.show-all-contacts-button`,
  REFRESH_BUTTON: `${TestIdDomain.ACTIVITIES}.refresh-button`,

  // ActivitiesFilter.js
  FILTER_SEARCH_INPUT: `${ActivitiesTestIdsScope.ACTIVITIES_FILTER}.search-input`,
  FILTER_TOGGLE_BUTTON: `${ActivitiesTestIdsScope.ACTIVITIES_FILTER}.filter-button`,
  getFilterCheckboxId: name => `${ActivitiesTestIdsScope.ACTIVITIES_FILTER}.${name}-checkbox`,

  // CallActivityItem.js
  getCallOutcomeSelectId: callHistoryId =>
    `${ActivitiesTestIdsScope.CALL_ACTIVITY_ITEM}.outcome-select-${callHistoryId}`,

  // CallNotes.js
  CALL_NOTES_SAVE_BUTTON: `${ActivitiesTestIdsScope.CALL_NOTES}.save-button`,
  CALL_NOTES_CANCEL_BUTTON: `${ActivitiesTestIdsScope.CALL_NOTES}.cancel-button`,
  CALL_NOTES_EDIT_BUTTON: `${ActivitiesTestIdsScope.CALL_NOTES}.edit-button`,
  CALL_NOTES_INPUT: `${ActivitiesTestIdsScope.CALL_NOTES}.notes-input`,

  // EmailActivityItem.js
  EMAIL_THREAD_BACK_BUTTON: `${ActivitiesTestIdsScope.EMAIL_ACTIVITY_ITEM}.back-button`,

  // EmailStatusPopup.js
  EMAIL_STATUS_CLOSE_BUTTON: `${ActivitiesTestIdsScope.EMAIL_STATUS_POPUP}.close-button`,

  // ContactsColumn.js
  CONTACTS_SCROLL_TOP_BUTTON: `${ActivitiesTestIdsScope.CONTACTS_COLUMN}.scroll-top-button`,

  // BodyAdditionalContent.js
  QUOTED_CONTENT_EXPAND_BUTTON: `${ActivitiesTestIdsScope.EMAIL_QUOTED_CONTENT}.expand-button`,

  // EmailAttachments.js
  getRemoveAttachmentButtonId: index =>
    `${ActivitiesTestIdsScope.EMAIL_ATTACHMENTS}.remove-button-${index}`,

  // NewEmailBody.js
  SNIPPETS_TOGGLE_BUTTON: `${ActivitiesTestIdsScope.NEW_EMAIL_BODY}.snippets-button`,
  EMAIL_BODY_EDITOR: `${ActivitiesTestIdsScope.NEW_EMAIL_BODY}.editor`,

  // SnippetsPopover.js
  SNIPPETS_SEARCH_INPUT: `${ActivitiesTestIdsScope.SNIPPETS_POPOVER}.search-input`,

  // NewEmailFields.js
  SUBJECT_INPUT: `${ActivitiesTestIdsScope.NEW_EMAIL_FIELDS}.subject-input`,

  // RecipientsFields.js
  RECIPIENTS_TO_SELECT: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.to-select`,
  RECIPIENTS_CC_SELECT: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.cc-select`,
  RECIPIENTS_BCC_SELECT: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.bcc-select`,
  RECIPIENTS_CC_TOGGLE_BUTTON: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.cc-button`,
  RECIPIENTS_BCC_TOGGLE_BUTTON: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.bcc-button`,
  RECIPIENTS_INPUT: `${ActivitiesTestIdsScope.RECIPIENTS_FIELDS}.recipient-input`,

  // NewEmailFooter.js
  ATTACH_FILE_BUTTON: `${ActivitiesTestIdsScope.NEW_EMAIL_FOOTER}.attach-button`,
  SEND_BUTTON: `${ActivitiesTestIdsScope.NEW_EMAIL_FOOTER}.send-button`,
};
